<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12lHpYR/cover.jpg?1733151293352" alt="This image is the cover for the book Consenting Adult"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Consenting Adult
      </h1>
      <p class="bookDescription body article font2">
        <b>In the shifting social landscape of America in the 1960s, a mother struggles to understand—and accept—her son’s homosexuality<br/><br/></b>Tessa Lynn considers herself independent and progressive, a liberated woman of the 1960s. And yet, when she receives a letter from her youngest son, Jeff, informing her that he is gay, Tessa is distraught. At a time when homosexuality is regarded as a mental illness, she struggles with how best to be a parent to a gay son—and how to protect her family from the prejudices of the era.Elegant and subtly drawn, <i>Consenting Adult</i> is a stunning tribute to familial bonds, and a sympathetic portrait of a mother whose best intentions are often clouded by the stereotypes of her time.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laura Z. Hobson
      </h2>
      
      <p class="authorDescription body article">Laura Z. Hobson (1900&ndash;1986) was an American novelist and short story writer. The daughter of Jewish immigrants, she is best known for her novels <i>Gentleman&rsquo;s Agreement</i> (1947), which deals with anti-Semitism in postwar America, and <i>Consenting Adult</i> (1975), about a mother coming to terms with her son&rsquo;s homosexuality, which was based upon her own experiences with her own son. Hobson died in New York City in 1986. <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?679f1b2f